(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wg-product-grid-dynamic"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__wgDynamicColorways) return;
  window.__wgDynamicColorways = true;
  var guideCache = new Map();
  var guideDialog, guideBody, guideTrigger, guideRequest = 0;
  function sizeGuideDialog() {
    if (guideDialog) return guideDialog;
    guideDialog = document.createElement('dialog');
    guideDialog.className = 'wg-size-guide-dialog';
    guideDialog.setAttribute('aria-label', 'Size guide');
    guideDialog.innerHTML = '<div class="wg-size-guide-dialog__header"><h2>Size guide</h2><button type="button" class="wg-size-guide-dialog__close" aria-label="Close size guide" autofocus>Close</button></div><div class="wg-size-guide-dialog__body" aria-live="polite"></div>';
    guideBody = guideDialog.querySelector('.wg-size-guide-dialog__body');
    guideDialog.addEventListener('click', function(event) {
      event.stopPropagation();
      var box = guideDialog.getBoundingClientRect();
      if (event.target.closest('.wg-size-guide-dialog__close') || (event.target === guideDialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom))) guideDialog.close();
    });
    guideDialog.addEventListener('keydown', function(event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.from(guideDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')).filter(function(node) { return node.getClientRects().length; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (first && ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last))) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    });
    guideDialog.addEventListener('close', function() {
      guideRequest++;
      if (guideTrigger && guideTrigger.isConnected) guideTrigger.focus();
    });
    document.body.appendChild(guideDialog);
    return guideDialog;
  }
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-wg-size-guide]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
    event.preventDefault();
    var url = link.href;
    var dialog = sizeGuideDialog();
    guideTrigger = link;
    var request = ++guideRequest;
    guideBody.textContent = 'Loading size guide…';
    dialog.showModal();
    if (!guideCache.has(url)) {
      guideCache.set(url, fetch(url, { credentials: 'same-origin' }).then(function(response) {
        if (!response.ok) throw new Error('Size guide unavailable');
        return response.text();
      }).then(function(html) {
        var page = new DOMParser().parseFromString(html, 'text/html');
        return page.querySelector('[data-wg-panel="size-chart"]');
      }).catch(function() { guideCache.delete(url); return null; }));
    }
    guideCache.get(url).then(function(chart) {
      if (!dialog.open || request !== guideRequest) return;
      guideBody.replaceChildren();
      if (chart && chart.textContent.trim()) {
        Array.from(chart.childNodes).forEach(function(node) { guideBody.appendChild(node.cloneNode(true)); });
        guideBody.querySelectorAll('script, iframe, form').forEach(function(node) { node.remove(); });
        guideBody.querySelectorAll('*').forEach(function(node) { Array.from(node.attributes).forEach(function(attribute) { if (/^on/i.test(attribute.name)) node.removeAttribute(attribute.name); }); });
      } else {
        var fallback = document.createElement('a');
        fallback.href = url;
        fallback.textContent = 'View sizing and product details';
        guideBody.appendChild(fallback);
      }
    });
  });

  function init(wrap) {
    if (wrap.__wgColorways) return;
    var grid = wrap.querySelector('[data-wg-grid]');
    if (!grid) return;
    wrap.__wgColorways = true;
    var templates = new Map();
    wrap.querySelectorAll('[data-wg-colorways-template]').forEach(function (template) {
      templates.set(template.dataset.url, template);
    });
    function apply() {
      var active = wrap.querySelector('.wg-tabs__tab.is-active');
      var catalog = wrap.dataset.wgCatalogOrder && active && active.dataset.handle === 'all';
      var direct = Array.from(grid.children).filter(function(c) { return c.classList.contains('wg-cell'); });
      if (catalog) {
        var ranks = wrap.dataset.wgCatalogOrder.split(',');
        var sorted = direct.slice().sort(function(a,b) {
          var ai = ranks.indexOf(a.dataset.url.split('/').pop());
          var bi = ranks.indexOf(b.dataset.url.split('/').pop());
          return (ai < 0 ? ranks.length : ai) - (bi < 0 ? ranks.length : bi);
        });
        sorted.forEach(function(cell, index) { if (grid.children[index] !== cell) grid.insertBefore(cell, grid.children[index] || null); });
      }
      direct.forEach(function(cell) {
        cell.removeAttribute('data-wg-auto-full');
      });
      // Catalog placement requested for this instance's ALL tab only.
      var activeTab = wrap.querySelector('.wg-tabs__tab.is-active');
      if (wrap.dataset.wgMoveProduct && activeTab && activeTab.dataset.handle === 'all') {
        var cells = Array.from(grid.children);
        var moving = cells.find(function (cell) { return cell.classList.contains('wg-cell') && cell.dataset.url === wrap.dataset.wgMoveProduct; });
        var anchor = cells.find(function (cell) { return cell.classList.contains('wg-cell') && cell.dataset.url === wrap.dataset.wgMoveAfter; });
        if (moving && anchor && anchor.nextElementSibling !== moving) grid.insertBefore(moving, anchor.nextSibling);
      }
      Array.from(grid.children).forEach(function (cell) {
        if (!cell.classList.contains('wg-cell')) return;
        var template = templates.get(cell.dataset.url);
        if (!template || template.dataset.enabled !== 'true') return;
        if (cell.hasAttribute('data-wg-colorways-active')) return;
        var row = template.content.firstElementChild;
        if (!row || !row.children.length) return;
        cell.prepend(row.cloneNode(true));
        cell.setAttribute('data-wg-colorways-active', '');
      });

      grid.querySelectorAll('.wg-qa-sizes, .wg-qa-matrix').forEach(function(picker) {
        if (picker.querySelector('[data-wg-size-guide]')) return;
        var cell = picker.closest('.wg-cell');
        if (!cell || !cell.dataset.url) return;
        var link = document.createElement('a');
        link.className = 'wg-size-guide-link';
        link.href = cell.dataset.url;
        link.setAttribute('data-wg-size-guide', '');
        link.textContent = 'Size guide';
        picker.appendChild(link);
      });
      if (matchMedia('(max-width: 749px)').matches && getComputedStyle(grid).gridTemplateColumns.split(' ').length === 2) {
        var run = [];
        function finishRun() { if (run.length % 2) run[run.length - 1].setAttribute('data-wg-auto-full', ''); run = []; }
        Array.from(grid.children).forEach(function(cell) {
          if (!cell.classList.contains('wg-cell')) return;
          var style = getComputedStyle(cell);
          if (style.gridColumnStart === '1' && style.gridColumnEnd === '-1') finishRun();
          else run.push(cell);
        });
        finishRun();
      }
    }
    apply();
    window.addEventListener('resize', function() { if (wrap.isConnected) apply(); });
    new MutationObserver(apply).observe(grid, { childList: true });
  }
  function initAll(ctx) {
    if (ctx.matches && ctx.matches('[data-wg-dynamic-colorways]')) init(ctx);
    ctx.querySelectorAll('[data-wg-dynamic-colorways]').forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wg-product-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__wgV3Colorways) return;
  window.__wgV3Colorways = true;
  var guideCache = new Map();
  var guideDialog, guideBody, guideTrigger, guideRequest = 0;
  function sizeGuideDialog() {
    if (guideDialog) return guideDialog;
    guideDialog = document.createElement('dialog');
    guideDialog.className = 'wg-size-guide-dialog';
    guideDialog.setAttribute('aria-label', 'Size guide');
    guideDialog.innerHTML = '<div class="wg-size-guide-dialog__header"><h2>Size guide</h2><button type="button" class="wg-size-guide-dialog__close" aria-label="Close size guide" autofocus>Close</button></div><div class="wg-size-guide-dialog__body" aria-live="polite"></div>';
    guideBody = guideDialog.querySelector('.wg-size-guide-dialog__body');
    guideDialog.addEventListener('click', function(event) {
      event.stopPropagation();
      var box = guideDialog.getBoundingClientRect();
      if (event.target.closest('.wg-size-guide-dialog__close') || (event.target === guideDialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom))) guideDialog.close();
    });
    guideDialog.addEventListener('keydown', function(event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.from(guideDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')).filter(function(node) { return node.getClientRects().length; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (first && ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last))) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    });
    guideDialog.addEventListener('close', function() {
      guideRequest++;
      if (guideTrigger && guideTrigger.isConnected) guideTrigger.focus();
    });
    document.body.appendChild(guideDialog);
    return guideDialog;
  }
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-wg-v3-size-guide]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
    event.preventDefault();
    var url = link.href;
    var dialog = sizeGuideDialog();
    guideTrigger = link;
    var request = ++guideRequest;
    guideBody.textContent = 'Loading size guide…';
    dialog.showModal();
    if (!guideCache.has(url)) {
      guideCache.set(url, fetch(url, { credentials: 'same-origin' }).then(function(response) {
        if (!response.ok) throw new Error('Size guide unavailable');
        return response.text();
      }).then(function(html) {
        var page = new DOMParser().parseFromString(html, 'text/html');
        return page.querySelector('[data-wg-panel="size-chart"]');
      }).catch(function() { guideCache.delete(url); return null; }));
    }
    guideCache.get(url).then(function(chart) {
      if (!dialog.open || request !== guideRequest) return;
      guideBody.replaceChildren();
      if (chart && chart.textContent.trim()) {
        Array.from(chart.childNodes).forEach(function(node) { guideBody.appendChild(node.cloneNode(true)); });
        guideBody.querySelectorAll('script, iframe, form').forEach(function(node) { node.remove(); });
        guideBody.querySelectorAll('*').forEach(function(node) { Array.from(node.attributes).forEach(function(attribute) { if (/^on/i.test(attribute.name)) node.removeAttribute(attribute.name); }); });
      } else {
        if (guideTrigger) guideTrigger.remove();
        dialog.close();
      }
    });
  });

  function init(wrap) {
    if (wrap.__wgV3Colorways) return;
    var grid = wrap.querySelector('[data-wg-grid]');
    if (!grid) return;
    wrap.__wgV3Colorways = true;
    var templates = new Map();
    wrap.querySelectorAll('[data-wg-colorways-template]').forEach(function (template) {
      templates.set(template.dataset.url, template);
    });
    function apply() {
      var active = wrap.querySelector('.wg-tabs__tab.is-active');
      var catalog = wrap.dataset.wgCatalogOrder && active && active.dataset.handle === 'all';
      var mobileCatalog = catalog && matchMedia('(max-width: 749px)').matches;
      wrap.toggleAttribute('data-wg-mobile-pet-row', !!mobileCatalog);
      var direct = Array.from(grid.children).filter(function(c) { return c.classList.contains('wg-cell'); });
      if (catalog) {
        var ranks = wrap.dataset.wgCatalogOrder.split(',');
        ranks = ranks.filter(function(handle) { return ['pet-scum-hoodie', 'mothlover-shirt', 'haunter-shirt'].indexOf(handle) === -1; });
        ranks.splice(ranks.indexOf('enchanters-denim') + 1, 0, 'pet-scum-hoodie', 'mothlover-shirt', 'haunter-shirt');
        var sorted = direct.slice().sort(function(a,b) {
          var ai = ranks.indexOf(a.dataset.url.split('/').pop());
          var bi = ranks.indexOf(b.dataset.url.split('/').pop());
          return (ai < 0 ? ranks.length : ai) - (bi < 0 ? ranks.length : bi);
        });
        sorted.forEach(function(cell, index) { if (grid.children[index] !== cell) grid.insertBefore(cell, grid.children[index] || null); });
      }
      direct.forEach(function(cell) {
        cell.removeAttribute('data-wg-auto-full');
      });
      Array.from(grid.children).forEach(function (cell) {
        if (!cell.classList.contains('wg-cell')) return;
        var template = templates.get(cell.dataset.url);
        if (!template || template.dataset.enabled !== 'true') return;
        if (cell.hasAttribute('data-wg-colorways-mounted')) return;
        var row = template.content.firstElementChild;
        if (!row || !row.children.length) return;
        cell.prepend(row.cloneNode(true));
        if (template.dataset.mobileEnabled === 'true') cell.setAttribute('data-wg-colorways-active', '');
        cell.setAttribute('data-wg-colorways-mounted', '');
      });

      grid.querySelectorAll('.wg-qa-sizes, .wg-qa-matrix').forEach(function(picker) {
        if (picker.querySelector('[data-wg-v3-size-guide]')) return;
        var cell = picker.closest('.wg-cell');
        if (!cell || !cell.dataset.url || cell.dataset.wgHasSizeChart !== 'true') return;
        var link = document.createElement('a');
        link.className = 'wg-size-guide-link';
        link.href = cell.dataset.url;
        link.setAttribute('data-wg-v3-size-guide', '');
        link.innerHTML = '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true" focusable="false" style="vertical-align:-2px;margin-inline-end:4px"><rect x="1" y="4" width="14" height="8" rx="1.2"/><path d="M4 4v3M7 4v2M10 4v3M13 4v2"/></svg>Size guide';
        picker.appendChild(link);
      });
      // Keep the Novulent collaboration adjacent without moving its DOM order.
      var collabShirt = grid.querySelector(':scope > .wg-cell[data-url="/products/wg-x-novulent-shirt"]');
      var collabHat = grid.querySelector(':scope > .wg-cell[data-url="/products/wg-x-novulent-hat"]');
      [collabShirt, collabHat].forEach(function(cell) {
        if (cell) { cell.style.gridColumn = ''; cell.style.gridRow = ''; }
      });
      var collabAnchor = grid.querySelector(':scope > .wg-cell[data-url="/products/sovereign-polo"]');
      if (matchMedia('(min-width: 750px)').matches && catalog && collabShirt && collabHat && collabAnchor) {
        var gridBox = grid.getBoundingClientRect();
        var anchorBox = collabAnchor.getBoundingClientRect();
        var gridStyle = getComputedStyle(grid);
        var columnCount = gridStyle.gridTemplateColumns.split(' ').length;
        var columnWidth = gridBox.width / columnCount;
        var rowHeights = gridStyle.gridTemplateRows.split(' ').map(parseFloat);
        var rowOffset = 0;
        var collabRow = 1;
        while (collabRow < rowHeights.length && rowOffset + rowHeights[collabRow - 1] <= anchorBox.top - gridBox.top + 1) {
          rowOffset += rowHeights[collabRow - 1];
          collabRow++;
        }
        var anchorColumn = Math.round((anchorBox.left - gridBox.left) / columnWidth) + 1;
        var anchorSpan = Math.round(anchorBox.width / columnWidth);
        
        var collabColumn = anchorColumn + anchorSpan;
        if (collabColumn + 1 > columnCount) { collabColumn = 1; collabRow++; }
        collabShirt.style.gridColumn = String(collabColumn);
        collabHat.style.gridColumn = String(collabColumn + 1);
        collabShirt.style.gridRow = collabHat.style.gridRow = String(collabRow);
      }
      if (matchMedia('(max-width: 749px)').matches && getComputedStyle(grid).gridTemplateColumns.split(' ').length === 2) {
        var run = [];
        function finishRun() { if (run.length % 2) run[run.length - 1].setAttribute('data-wg-auto-full', ''); run = []; }
        Array.from(grid.children).forEach(function(cell) {
          if (!cell.classList.contains('wg-cell')) return;
          var style = getComputedStyle(cell);
          if (style.gridColumnStart === '1' && style.gridColumnEnd === '-1') finishRun();
          else run.push(cell);
        });
        finishRun();
      }
    }
    apply();
    window.addEventListener('resize', function() { if (wrap.isConnected) apply(); });
    new MutationObserver(apply).observe(grid, { childList: true });
  }
  function initAll(ctx) {
    if (ctx.matches && ctx.matches('[data-wg-v3-colorways]')) init(ctx);
    ctx.querySelectorAll('[data-wg-v3-colorways]').forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();


  } catch(e) { console.error(e); }
})();
})();
